
import apicalls from "../../api/apiCalls";
import debounce from "../../utils/debounce";
import { getTransactions } from "./api";

export const getTransactionGrid = async (id,search,callback,pageNo,pageSize=20) => {
    const response = await getTransactions(id,search, pageNo, pageSize);
    if (response.ok) {
      callback(response.data,null)
    } else {
      callback(null,apicalls.isErrorDispaly(response))
    }
  };
  export const debouncedGrid=debounce(getTransactionGrid)

